import { buildEmailList } from 'features/sendouts/components/drawers/CreateSendoutDrawer/SendoutForm/SendoutForm.utils';

export const OTHER_INTERVIEWER_FORM_FIELDS_MAP = {
  FullName: {
    key: 'otherInterviewerFullName',
    paramKey: 'full_name'
  },
  Email: {
    key: 'otherInterviewerEmail',
    paramKey: 'email'
  },
  CarbonCopy: {
    key: 'otherInterviewerCarbonCopy',
    paramKey: 'cc_emails',
    outboundAccesor: buildEmailList
  }
};
